import { API2_HOST } from '../../helpers/urlHelper';
import {
  baseSearch,
  basePost,
  basePatchNoId,
  baseGetNoId
} from 'services/base-services/baseService';

const baseURL = `${API2_HOST}/sm-configs`;
const getByParam = async (skillLevelId, areaId) => {
  return await baseGetNoId(`${baseURL}/by-param/${skillLevelId}/${areaId}`);
};

const search = async request => {
  return await baseSearch(baseURL, request);
};

const post = async request => {
  return await basePost(baseURL, request);
};

const patch = async (skillLevelId, areaId, request) => {
  return await basePatchNoId(`${baseURL}/${skillLevelId}/${areaId}`, request);
};

export { search, post, patch, getByParam };
